var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import NavBar from 'components/NavBar/NavBar.container.vue';
import FreeAccountNotificationBarContainer from '@/components/FreeAccountNoticationBar/FreeAccountNotificationBar.container.vue';
import V4IntroModal from '@/components/V4IntroModal/V4IntroModal.vue';
import DecizapGoOffer from '@/components/DecizapGoOffer/DecizapGoOffer.vue';
import { readDecizapGoOffer } from '@/components/DecizapGoOffer/offerStorage';
import { Component, Vue } from 'vue-property-decorator';
import { connect } from '@/overmind';
import { hasAtlasV4, hasAtlasV4Invite } from '@/shared/utils/helpers';
let MainLayout = class MainLayout extends Vue {
    constructor() {
        super(...arguments);
        this.decizapGoOffer = readDecizapGoOffer();
    }
    /**
     * Usuário da sessão: currentUser (overmind) é a fonte primária; o fallback
     * cobre o primeiro render antes de o estado hidratar (vue-auth mantém o user
     * em cache).
     */
    get sessionUser() {
        const stateUser = this.currentUser;
        // Sem optional chaining: o ts-loader/webpack desta config nao parseia `?.`
        const auth = Vue.auth;
        const authUser = auth && typeof auth.user === 'function' ? auth.user() : null;
        return stateUser && Object.keys(stateUser).length > 0 ? stateUser : authUser;
    }
    /**
     * Só quem foi convidado e ainda não ativou a nova versão vê o modal — quem
     * já tem `atlas_v4` está na nova experiência e não precisa de convite.
     */
    get showV4Intro() {
        const user = this.sessionUser;
        return hasAtlasV4Invite(user) && !hasAtlasV4(user);
    }
};
MainLayout = __decorate([
    Component(connect(({ state }) => ({
        currentUser: state.users.currentUser,
    }), {
        name: 'MainLayout',
        components: {
            NavBar,
            FreeAccountNotificationBarContainer,
            V4IntroModal,
            DecizapGoOffer,
        },
    }))
], MainLayout);
export default MainLayout;
